import React from "react";
import { Component } from "preact";
import styles from "./Dropdown.scss";

const arrowIcon = require("../../assets/ic_dropdown.svg");
const hollowArrow = require("../../assets/ic_expand_more.svg");
const snaggleTooth = require("../../assets/ic_rectangle_dropdown_white.svg");

const arrows = {
  solid: arrowIcon,
  hollow: hollowArrow
};

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.startTimeout = this.startTimeout.bind(this);
    this.cancelTimeout = this.cancelTimeout.bind(this);
  }

  startTimeout() {
    let { open, openToggle, closeToggle } = this.props;
    if (open) {
      this.timeout = setTimeout(() => {
        if (closeToggle) {
          closeToggle();
        } else {
          openToggle();
        }
      }, 400);
    }
  }

  cancelTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  render() {
    let {
      title,
      open,
      openToggle,
      closeToggle,
      children,
      hasDone,
      icon = "solid"
    } = this.props;
    return (
      <div
        style={{ position: "relative", display: "inline-block" }}
        onMouseLeave={this.startTimeout}
        onMouseEnter={openToggle}
      >
        <button
          className={styles.mainButton}
          onClick={open ? closeToggle : openToggle}
          aria-expanded={open ? "true" : "false"}
        >
          <h3 className={styles.title}>{title}</h3>{" "}
          <img
            src={arrows[icon]}
            className={styles.icon}
            style={{ transform: `rotateZ(${open ? -180 : 0}deg)` }}
            alt="Open Arrow"
          />
        </button>
        {open ? (
          <div
            className={styles.dropdownBody}
            onMouseEnter={this.cancelTimeout}
          >
            <img
              src={snaggleTooth}
              className={styles.snaggleTooth}
              alt={title}
            />
            {children}
            {hasDone ? (
              <button
                className={styles.doneButton}
                onClick={closeToggle}
                aria-label="Done"
              >
                Done
              </button>
            ) : null}
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }
}

export default Dropdown;
